/**
 * กล้องไม่ทะลุภูเขาขอบแผนที่ (ผู้ใช้เจอ 10 ต.ค.: วาร์ปมาโผล่ประตูริมแผนที่แล้วภูเขาบังจอเกือบครึ่ง)
 *
 * ภูเขาวางเป็นวงรอบขอบ (props.ts: ห่างกลาง half + 8..14) กล้องมองจากทิศคงที่ ยืนริมขอบด้านที่กล้องอยู่
 * กล้องจึงไปอยู่หลังวงภูเขา — หดระยะกล้องลงให้ตำแหน่งกล้อง (แนวราบ) อยู่ในกรอบ `bound`
 * เดินออกห่างขอบแล้วกลับไประยะที่ผู้เล่นซูมไว้เอง · pure function มีเทสต์
 */

/**
 * ระยะกล้องที่ใช้ได้จริง: ไม่เกิน `want` และไม่ทำให้กล้องออกนอกกรอบ ±bound (ไม่ต่ำกว่า `min`)
 * ตำแหน่ง ArcRotateCamera: x = tx + r·cos(alpha)·sin(beta) · z = tz + r·sin(alpha)·sin(beta)
 */
export function fitCameraRadius(
  tx: number, tz: number, alpha: number, beta: number, want: number, bound: number, min: number,
): number {
  const s = Math.sin(beta);
  const dx = Math.cos(alpha) * s;
  const dz = Math.sin(alpha) * s;
  let r = want;
  const limit = (t: number, d: number): void => {
    if (Math.abs(d) < 1e-6) return;
    const edge = d > 0 ? bound : -bound;
    const max = (edge - t) / d;
    if (max >= 0) r = Math.min(r, max);
  };
  limit(tx, dx);
  limit(tz, dz);
  return Math.max(min, Math.min(want, r));
}
